import { FC } from 'react';
import ProBreadcrumb, { BreadcrumbProps } from './breadcrumb';
import ProBreadcrumbItem, { BreadcrumbItemProps } from './item';
import ProBreadcrumbSeparator, { BreadcrumbSeparatorProps } from './separator';

export type IBreadcrumbComponent = FC<BreadcrumbProps> & {
  Item: FC<BreadcrumbItemProps>;
  Separator: FC<BreadcrumbSeparatorProps>;
};

const TransBreadcrumb = ProBreadcrumb as IBreadcrumbComponent;
TransBreadcrumb.Item = ProBreadcrumbItem;
TransBreadcrumb.Separator = ProBreadcrumbSeparator;

export default TransBreadcrumb;
